import { FC } from 'react';
import { DataGridProProps, GridColDef } from '@mui/x-data-grid-pro';

import DataGridPro from '../../../../../components/CDGridPro';

import { DspAudience as DspAudienceSource } from '../../../../../types/DspEntity';

type CampaignAdGroupAudienceTargetingDataGridProps = Omit<DataGridProProps, 'columns' | 'rows'> & {
    rows: DspAudienceSource[];
};

const CampaignAdGroupAudienceTargetingDataGrid: FC<CampaignAdGroupAudienceTargetingDataGridProps> = ({
    rows,
    ...props
}) => {
    const columns: GridColDef[] = [
        {
            flex: 1,
            field: 'category',
            headerName: 'Audience Category',
            filterable: false,
        },
        {
            flex: 1,
            field: 'audienceName',
            headerName: 'Audience Name',
            filterable: false,
        },
    ];

    const getRowId = (row: DspAudienceSource): string | number => {
        return row.audienceId as string;
    };

    return (
        <DataGridPro
            // Overridable props
            pageSize={5}
            {...props}
            disableColumnPinning
            getRowId={getRowId}
            columns={columns}
            rows={rows}
            slots={{
                toolbar: null,
            }}
        />
    );
};
export default CampaignAdGroupAudienceTargetingDataGrid;
